<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Interacciones</h4>
        </div>
        <div class="col-1">
          <button class="btn-help" type="button" title="Abrir ayuda"
                  @click="showModalHelp = true"
                  aria-label="Abrir ayuda de interacciones medicamentosas">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Interacciones Medicamentosas">
      <AyudaInteraccionMed />
    </Modal>
    <hr>
    <!-- DataTable -->
    <DataTable
      :data="interacciones"
      :columns="columnas"
      idField="idInteraccionMed"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarVer="false"
      mensajeVacio="No existen interacciones registradas."
      @refresh="cargarTodos()"
      @create="abrirModalCrear()"
      @edit="row => abrirModalEditar(row.idInteraccionMed)"
      @delete="row => deleteInteraccionMed(row.idInteraccionMed)"
    >
      <template #cell-severidad="{ row }">
        <span class="badge-severidad" :class="getClaseSeveridad(row.severidad)">
          {{ getTextoSeveridad(row.severidad) }}
        </span>
      </template>
      <template #cell-estado="{ row }">
        <span class="badge-estado" :class="row.estado === 1 ? 'activo' : 'inactivo'">
          {{ row.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
        </span>
      </template>
    </DataTable>
    <!-- Modal -->
    <div class="modal fade" id="modalInteraccion" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ tituloModal }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3 mb-3">
              <div class="col-md-12">
                <label class="form-label">Medicamento 1</label>
                <MedicamentoSelect
                  v-model="form.idElemento1"
                  placeholder="Escriba para buscar..."
                  :min-chars="2"
                  :tipo-elem="2"
                />
              </div>
            </div>
            <div class="row g-3 mb-3">
              <div class="col-md-12">
                <label class="form-label">Medicamento 2</label>
                <MedicamentoSelect
                  v-model="form.idElemento2"
                  placeholder="Escriba para buscar..."
                  :min-chars="2"
                  :tipo-elem="2"
                />
              </div>
            </div>
            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label class="form-label">Severidad</label>
                <select class="form-control" v-model="form.severidad">
                  <option :value="1">LEVE</option>
                  <option :value="2">MODERADA</option>
                  <option :value="3">GRAVE</option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label">Estado</label>
                <select class="form-control" v-model="form.estado">
                  <option :value="1">ACTIVO</option>
                  <option :value="0">INACTIVO</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Descripción</label>
              <textarea class="form-control" rows="3" v-model="form.descripcion"
                        style="text-transform:uppercase"></textarea>
            </div>
            <div class="mb-3">
              <label class="form-label">Recomendación</label>
              <textarea class="form-control" rows="3" v-model="form.recomendacion"
                        style="text-transform:uppercase"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            <button class="btn btn-primary" @click="guardar()">Guardar</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout              from '@/components/Layout.vue'
import Footer              from '@/components/Footer.vue'
import DataTable           from '@/components/DataTable.vue'
import MedicamentoSelect   from '@/components/MedicamentoSelect.vue'
import AyudaInteraccionMed from '@/views/ayuda/AyudaInteraccionMed.vue'
import api                 from '@/services/api'
import swal2               from 'sweetalert2'
import { openModal, closeModal } from '@/modules/modalHelper.js'

export default {
  name: 'InteraccionMedGestion',
  components: { Layout, Footer, DataTable, MedicamentoSelect, AyudaInteraccionMed },
  data() {
    return {
      interacciones: [],
      tituloModal:   '',
      form: {
        idInteraccionMed: null,
        idElemento1:      null,
        idElemento2:      null,
        severidad:        1,
        descripcion:      '',
        recomendacion:    '',
        estado:           1,
      },
columnas: [
  { field: 'nombreElemento1', label: 'Medicamento 1' },
  { field: 'nombreElemento2', label: 'Medicamento 2' },
  {
    field: 'severidad',
    label: 'Severidad',
    filterType: 'select',
    filterOptions: [
      { label: 'Leve',     value: 1 },
      { label: 'Moderada', value: 2 },
      { label: 'Grave',    value: 3 },
    ],
  },
  { field: 'descripcion',   label: 'Descripción' },
  { field: 'recomendacion', label: 'Recomendación' },
  {
    field: 'estado',
    label: 'Estado',
    filterType: 'select',
    filterOptions: [
      { label: 'Activo',   value: 1 },
      { label: 'Inactivo', value: 0 },
    ],
  },
],
      showModalHelp: false,
    }
  },
  async mounted() {
    this.$refs.layoutRef.toggleParametros()
    await this.cargarTodos()
  },
  methods: {
    async cargarTodos() {
      try {
        const { data } = await api.get('/interaccion-med/getAll')
        this.interacciones = data
      } catch {
        swal2.fire('Error', 'No se pudieron cargar las interacciones.', 'error')
      }
    },
    abrirModalCrear() {
      this.tituloModal = 'Nueva Interacción Medicamentosa'
      this.form = {
        idInteraccionMed: null, idElemento1: null, idElemento2: null,
        severidad: 1, descripcion: '', recomendacion: '', estado: 1,
      }
      openModal('modalInteraccion')
    },
    async abrirModalEditar(idInteraccionMed) {
      try {
        const { data } = await api.get(`/interaccion-med/getById/${idInteraccionMed}`)
        this.form        = data
        this.tituloModal = 'Editar Interacción Medicamentosa'
        openModal('modalInteraccion')
      } catch {
        swal2.fire('Error', 'No se pudo cargar el registro.', 'error')
      }
    },
    async guardar() {
      if (!this.form.idElemento1 || !this.form.idElemento2) {
        swal2.fire('Validación', 'Debe seleccionar ambos medicamentos.', 'warning')
        return
      }
      if (this.form.idElemento1 === this.form.idElemento2) {
        swal2.fire('Validación', 'No puede seleccionar el mismo medicamento dos veces.', 'warning')
        return
      }
      try {
        await api.post('/interaccion-med/guardar', this.form)
        swal2.fire('Correcto', 'Registro guardado correctamente.', 'success')
        closeModal('modalInteraccion')
        await this.cargarTodos()
      } catch {
        swal2.fire('Error', 'No se pudo guardar la información.', 'error')
      }
    },
    async deleteInteraccionMed(idInteraccionMed) {
      const result = await swal2.fire({
        title: '¿Eliminar registro?', text: 'El registro quedará inactivo.',
        icon: 'warning', showCancelButton: true,
        confirmButtonText: 'Sí, eliminar', cancelButtonText: 'Cancelar',
      })
      if (!result.isConfirmed) return
      try {
        await api.post('/interaccion-med/eliminar', { idInteraccionMed })
        swal2.fire('Correcto', 'Registro eliminado correctamente.', 'success')
        await this.cargarTodos()
      } catch {
        swal2.fire('Error', 'No se pudo eliminar el registro.', 'error')
      }
    },
    getTextoSeveridad(s) { return { 1: 'LEVE', 2: 'MODERADA', 3: 'GRAVE' }[s] || '' },
    getClaseSeveridad(s) { return { 1: 'leve', 2: 'moderada', 3: 'grave' }[s] || '' },
  },
}
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.badge-severidad, .badge-estado {
  display: inline-block; padding: 4px 10px;
  border-radius: 4px; font-size: 0.8rem; font-weight: 600;
}
.leve     { background-color: #f9e79f; }
.moderada { background-color: #f8c471; }
.grave    { background-color: #ec7063; color: white; }
.activo   { background-color: #7dcea0; }
.inactivo { background-color: #d5d8dc; }
</style>